export interface IFile {
  id: number;
  file: string;
  file_type: number;
  name: string;
  file_size: number;
  file_format: string;
}
